import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { Breadcrumb } from 'antd';
import qs from 'query-string';
import generatePath from '~settings/routing';
import {
  HpSetting,
  UpSetting,
  SopSetting,
  BfpSetting,
  HeroBanner,
  WorldPin,
} from 'common/components/svgs';

export default function CityHomepage({ match, location }) {
  const { slug: citySlug, cityId } = qs.parse(location?.search);
  const cityName = decodeURIComponent(match?.params?.name);
  const { t } = useTranslation();

  const settingConfig = [
    {
      icon: <HpSetting className="setting-icon" />,
      name: t('cms.dashboard.strategy.destination_list.hp'),
      slug: 'hp',
      bgColor: 'hp',
      link: generatePath('strategy.homePage', { name: cityName }, { slug: citySlug }),
    },
    {
      icon: <UpSetting className="setting-icon" />,
      name: t('cms.dashboard.strategy.destination_list.up'),
      slug: 'up',
      bgColor: 'up',
      link: '#',
    },
    {
      icon: <SopSetting className="setting-icon" />,
      name: t('cms.dashboard.strategy.destination_list.sop'),
      bgColor: 'sop',
      slug: 'sop',
      link: '#',
    },
    {
      icon: <BfpSetting className="setting-icon" />,
      name: t('cms.dashboard.strategy.destination_list.bfp'),
      bgColor: 'bfp',
      slug: 'bfp',
      link: '#',
    },
    {
      icon: <HeroBanner className="setting-icon" />,
      name: t('cms.dashboard.strategy.destination_list.cn_banner'),
      bgColor: 'hero-banner',
      slug: 'cn-banner',
      link: generatePath(
        'strategy.heroBanner',
        { name: cityName },
        { slug: citySlug, cityId, locale: 'CN' },
      ),
    },
    {
      icon: <HeroBanner className="setting-icon" />,
      name: t('cms.dashboard.strategy.destination_list.row_banner'),
      bgColor: 'hero-banner',
      slug: 'row-banner',
      link: generatePath(
        'strategy.heroBanner',
        { name: cityName },
        { slug: citySlug, cityId, locale: 'ROW' },
      ),
    },
  ];

  return (
    <div className="city-homepage">
      <div className="breadcrumb-wrapper">
        <Breadcrumb>
          <Breadcrumb.Item>
            <Link to={generatePath('strategy')}>
              {t('cms.dashboard.strategy.city_homepage.subtitle')}
            </Link>
          </Breadcrumb.Item>
          <Breadcrumb.Item>
            <Link to={generatePath('strategy')}>{cityName}</Link>
          </Breadcrumb.Item>
        </Breadcrumb>
        <p className="city-title">{cityName}</p>
      </div>
      <div className="setting-wrapper">
        {settingConfig.map((config, index) => {
          return ['hp', 'cn-banner', 'row-banner'].includes(config.slug) ? (
            <Link to={config.link} className="single-wrapper" key={index}>
              <If condition={['cn-banner', 'row-banner'].includes(config.slug)}>
                <div className="banner-icon">
                  <WorldPin className="world-pin-icon" />
                  <span className="row-cn">
                    {config.slug === 'cn-banner'
                      ? t('cms.dashboard.strategy.destination_list.cn')
                      : t('cms.dashboard.strategy.destination_list.row')}
                  </span>
                </div>
              </If>
              <div className={`setting-icon-wrapper ${config.bgColor}`}>{config.icon}</div>
              <div className="setting-name">{config.name}</div>
            </Link>
          ) : (
            <div className="single-wrapper" key={index}>
              <div className={`setting-icon-wrapper ${config.bgColor}`}>{config.icon}</div>
              <div className="setting-name">{config.name}</div>
            </div>
          );
        })}
      </div>
    </div>
  );
}
